import React from 'react'
import { Spin } from 'antd'

function Loading () {
  return (<div className='flex flex-align-center flex-justify-center w-100 h-100'><Spin /></div>)
}

export default Loading
